"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetChart = void 0;
var Highcharts = require("highcharts");
var highcharts_react_official_1 = require("highcharts-react-official");
var React = require("react");
// @ts-ignore
var server_1 = require("react-dom/server");
var theme_1 = require("../../../utils/theme");
var ApWidgetChart_utils_1 = require("./ApWidgetChart.utils");
var styles_1 = require("./styles");
var defaultOptions = {
    chart: {
        height: 222,
        type: 'column',
    },
    credits: {
        enabled: false,
    },
    legend: {
        align: 'center',
        itemStyle: {
            color: '#333333',
            fontSize: '11px',
            fontWeight: 'normal',
        },
        symbolRadius: 0,
        verticalAlign: 'top',
        x: 16,
    },
    plotOptions: {
        column: {
            borderWidth: 0,
            groupPadding: 0.33,
            pointPadding: 0,
            pointWidth: 3,
        },
    },
    series: [],
    title: {
        text: '',
    },
    tooltip: {
        shared: true,
        useHTML: true,
    },
    xAxis: {
        labels: {
            step: 1,
            style: {
                color: theme_1.colors.grey5,
                fontSize: '11px',
            },
        },
    },
    yAxis: {
        max: 100,
        min: 0,
        tickAmount: 5,
        title: {
            text: '',
        },
    },
};
exports.ApWidgetChart = function (_a) {
    var data = _a.data, type = _a.type;
    type = type || 'column';
    var valueType = data && data[0] && data[0].valueType;
    var currency = data && data[0] && data[0].currency;
    var currentPeriodData = data.map(function (item) { return item.values[0]; });
    var prevPeriodData = data.map(function (item) { return item.values[1] || 0; });
    var maxValue = Math.max.apply(Math, __spread(currentPeriodData, prevPeriodData));
    var minValue = Math.min.apply(Math, __spread(currentPeriodData, prevPeriodData));
    var _b = ApWidgetChart_utils_1.getAxisMinMaxValues(maxValue, minValue, valueType), yAxisMax = _b.yAxisMax, yAxisMin = _b.yAxisMin;
    var currentSeries = {
        color: theme_1.colors.chartDarkBlue,
        data: currentPeriodData,
        marker: {
            enabled: false,
        },
        name: 'Current period',
    };
    var prevSeries = {
        color: theme_1.colors.chartLightBlue,
        data: prevPeriodData,
        marker: {
            enabled: false,
        },
        name: 'Prior period',
    };
    var hasPrevSeries = prevPeriodData.filter(Boolean).length > 0;
    var options = __assign(__assign({}, defaultOptions), { chart: __assign(__assign({}, defaultOptions.chart), { type: type }), series: hasPrevSeries ? [currentSeries, prevSeries] : [currentSeries], tooltip: __assign(__assign({}, defaultOptions.tooltip), { shared: true, useHTML: true, backgroundColor: theme_1.colors.white, formatter: function () {
                var tooltip = this;
                var points = (tooltip.points || []);
                return server_1.renderToString(React.createElement(styles_1.TooltipContainer, null, points.map(function (point) {
                    return point ? (React.createElement(styles_1.TooltipItem, { key: point.series.name + "-" + point.color },
                        React.createElement("span", null,
                            React.createElement(styles_1.TooltipColor, { color: point.color }),
                            React.createElement(styles_1.TooltipItemName, null, point.series.name)),
                        React.createElement(styles_1.TooltipItemValue, null, ApWidgetChart_utils_1.formatValue(point.y, valueType, currency)))) : null;
                })));
            } }), xAxis: __assign(__assign({}, defaultOptions.xAxis), { categories: data.map(function (item) { return item.label; }) }), yAxis: __assign(__assign({}, defaultOptions.yAxis), { endOnTick: true, labels: {
                formatter: function () {
                    var yAxis = this;
                    return ApWidgetChart_utils_1.formatValue(yAxis.value, valueType, currency);
                },
                style: {
                    color: theme_1.colors.grey5,
                    fontSize: '11px',
                },
            }, max: yAxisMax, min: yAxisMin, startOnTick: true }) });
    return (React.createElement(styles_1.Wrapper, null,
        React.createElement(highcharts_react_official_1.default, { highcharts: Highcharts, options: options })));
};
//# sourceMappingURL=ApWidgetChart.js.map